module.exports = __webpack_public_path__ + "img/icon.cc6bf6c2.png";